/* eslint-disable jsx-a11y/anchor-is-valid */
import axios from 'axios'
import React, { FC, useState, useEffect } from 'react'
import { KTSVG } from '../../helpers'
import { LanguageHelp } from '../../../_metronic/helpers/LanguageHelper'
import { useFormik } from 'formik'
import { toast } from 'react-toastify'
import * as Yup from 'yup'
import clsx from 'clsx'
import CreatableSelect from "react-select/creatable"
import makeAnimated from 'react-select/animated'
import { useThemeMode } from '../layout/theme-mode/ThemeModeProvider'

export class AddMultipleSubjectGroupDto { id = ""; name = ""; subSubjectGroupList: object[] = []; }

type Props = {}
const animatedComponents = makeAnimated();
const AddMultipleSubjectGroupModal: FC<Props> = ({ }) => {
  const [isSubjectGroupSuggestionsGetted, setIsSubjectGroupSuggestionsGetted] = React.useState(false);

  const createChannelSchema = Yup.object().shape({
    // name: Yup.string()
    //   .min(3, LanguageHelp('Minimum 3 symbols'))
    //   .max(50, LanguageHelp('Maximum 50 symbols'))
    //   .required(LanguageHelp('Subject group is required')),
    type: Yup.string(),
    subSubjectGroupList: Yup.array().when('type',
      (type, schema) => {
        if (isSubjectGroupSuggestionsGetted) {
          return schema.min(1, "minimum 1 pick").of(Yup.object().shape({
            label: Yup.string().min(3, LanguageHelp('Minimum 3 symbols'))
          }))
        } else {
          return schema;
        }
      }),
  })
  const [addMultipleSubjectGroupDto, setAddMultipleSubjectGroupDto] = useState(new AddMultipleSubjectGroupDto())
  const { mode } = useThemeMode()

  const formik = useFormik({
    initialValues: addMultipleSubjectGroupDto,
    // initialTouched:{ 
    //   name: true,
    //   subSubjectGroupList: true,
    // },
    validationSchema: createChannelSchema,
    // validateOnMount: true,
    onSubmit: async (values, { setSubmitting }) => {
      isSuccess = false
      try {
        var isSuccess = await addMultipleSubjectGroupModal(values)
        console.log(isSuccess, "isSuccess")
      } catch (ex) {
        if (ex instanceof Error) {
          toast.error(LanguageHelp(ex.message));
        } else {
          console.log("Unexpected error", ex);
        }
      } finally {
        setSubmitting(true)
        document.getElementById("buttonCreateDismiss")?.click()
        if (isSuccess == true) {
          document.body.classList.remove('modal-open')
          formik.resetForm();
          setIsSubjectGroupSuggestionsGetted(false);
        }
      }
    },
  })

  const addMultipleSubjectGroupModal = async (addMultipleSubjectGroupDto: AddMultipleSubjectGroupDto) => {
    var subSubjectGroupList: string[] = []
    addMultipleSubjectGroupDto.subSubjectGroupList.forEach(subjectGroupOption => {
      subSubjectGroupList.push(Object(subjectGroupOption)['label'])
    });

    var payload = {
      name: addMultipleSubjectGroupDto.name,
      subSubjectGroups: subSubjectGroupList,
    }

    return axios
      .post(`${process.env.REACT_APP_API_URL}/reviewsubjectGroup/AddOrUpdateReviewSubjectGroup`, payload)
      .then((response) => {
        if (response.data.httpStatusCode === 200) {

          if (response.data.message !== null) {
            toast.warning(LanguageHelp(response.data.message));
          } else {
            toast.success(response.data.result);
          }
        } else {
          toast.error(response.data.message);
        }
        return response.data.result;
      })
      .then((response: any) => response != null)
  }

  return (
    <div className='modal fade' id='kt_modal_AddMultipleSubjectGroup' aria-hidden='true'>
      {/* <div className='modal-dialog modal-xl'> */}
      <div className='modal-dialog modal-dialog-centered mw-750px'>
        <div className='modal-content rounded'>
          <div>
            <div className='modal-header'>
              {/* begin::Modal title */}
              <h2 className='fw-bolder'>{LanguageHelp('Add Multiple Subject Group')}</h2>
              {/* end::Modal title */}
              {/* begin::Close */}
              <div className='btn btn-sm btn-icon btn-active-color-primary' id='buttonCreateDismiss' data-bs-dismiss='modal'>
                <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-1' />
              </div>
              {/* end::Close */}
            </div>
          </div>
          <div className='modal-header justify-content-end border-0 pb-0'>
            <form className='form' style={{ minWidth: "-webkit-fill-available" }} onSubmit={formik.handleSubmit} noValidate>
              {/* begin::Scroll */}
              <div
                id='kt_modal_add_subjectGroup_scroll'
                data-kt-scroll='true'
              >
                {/* begin::Input group */}
                <div className='fv-row mb-7'>
                  <div className='row mb-6'>
                    <label className='col-lg-4 col-form-label fw-bold fs-6'>{LanguageHelp('Parent Subject Group')} {LanguageHelp('(optional)')}</label>
                    <div className='col-lg-8 fv-row'>
                      <input
                        placeholder={LanguageHelp('Parent Subject Group')}
                        {...formik.getFieldProps('name')}
                        type='text'
                        name='name'
                        className={clsx('form-control form-control-lg form-control-solid')}
                        autoComplete='off'
                        disabled={formik.isSubmitting}
                      />
                      {/* {formik.touched.name && formik.errors.name && (
                        <div className='fv-plugins-message-container'>
                          <div className='fv-help-block'>
                            <span role='alert'>{formik.errors.name}</span>
                          </div>
                        </div>
                      )} */}
                    </div>
                  </div>
                </div>

                <div className='fv-row mb-7'>
                  <div className='row mb-6'>
                    <label className='col-lg-4 col-form-label fw-bold fs-6'>{LanguageHelp('Subject Groups')}</label>
                    <div className='col-lg-8 fv-row'>
                      <CreatableSelect
                        defaultValue={[]}
                        isMulti
                        className={mode === 'light' ? 'basic-multi-select' : 'basic-multi-select dark'}
                        classNamePrefix="select"
                        isClearable={true}
                        isSearchable={true}
                        components={animatedComponents}
                        noOptionsMessage={() => LanguageHelp('You can add a new value!')}
                        placeholder={LanguageHelp('Write one/several subject group(s)...')}
                        formatCreateLabel={(inputValue) => `${LanguageHelp('Create new...')} ${inputValue}`}
                        {...formik.getFieldProps('subSubjectGroupList')}
                        onChange={(subSubjectGroupList) => formik.setFieldValue('subSubjectGroupList', subSubjectGroupList)}
                        onCreateOption={(inputValue) => {
                          const values = inputValue.split(',').map(v => v.trim()).filter(v => v);
                          const current = formik.values.subSubjectGroupList || [];
                          const newValues = [
                            ...current,
                            ...values.map(v => ({ label: v, value: v }))
                          ];
                          formik.setFieldValue('subSubjectGroupList', newValues);
                        }}
                        styles={{
                          control: (base) => ({ ...base, fontWeight: '600' })
                          , multiValueRemove: (base) => ({ ...base, paddingLeft: '0px', paddingRight: '1px' })
                          , menu: (base) => ({ ...base, paddingLeft: '0px', paddingRight: '1px' })
                        }}
                      />
                      <div className='form-text'>{LanguageHelp("You can enter multiple values ​​separated by commas.")}</div>
                      {/* {formik.errors.subSubjectGroupList !== undefined && (
                        <div className='fv-plugins-message-container'>
                          <div className='fv-help-block'>{LanguageHelp("The subjectGroups to be searched must be at least one, and the number of letters of the subjectGroups must be at least 3.")}</div>
                        </div>
                      )} */}
                    </div>
                  </div>
                </div>
                {/* end::Input group */}


              </div>
              {/* end::Scroll */}

              {/* begin::Actions */}
              <div className='text-center pt-10 pb-5'>
                <button
                  type='submit'
                  className='btn btn-primary mb-2'
                  data-kt-multisubjectgroup-modal-action='submit'
                  disabled={formik.isSubmitting || !formik.isValid || !formik.touched}
                >
                  <i className="fas fa-paper-plane"></i>
                  <span className='indicator-label'>{LanguageHelp('Submit')}</span>
                  {(formik.isSubmitting) && (
                    <span className='indicator-progress'>
                      {LanguageHelp('Please wait...')}{' '}
                      <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                  )}
                </button>
              </div>
              {/* end::Actions */}
            </form>
          </div>
        </div></div>
    </div>
  )
}

export { AddMultipleSubjectGroupModal }
